import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { showToast } from 'Core/redux/toast/slice';

import { VendorService } from '../../../service/api/vendor-service';
import { redux } from 'Core/redux';



export const STORE_KEY = 'vendors';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  filters: {
    status: {
      value: '',
      label: ''
    },
    vendor: {
      value: '',
      label: ''
    }
  },
  searchTerm: '',
  showTileView: true,
  filterVisible: false
};

export const fetchVendorsWithFilters = createAsyncThunk(
  'vendors/fetchVendorsWithFilters',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await VendorService.getAllVendorsList(filters);
      return response.response;
    } catch (error) {

      return rejectWithValue(error.message || 'Failed to fetch vendors');
    }
  }
);

export const createVendor = createAsyncThunk(
  'vendors/createVendor',
  async (vendorData, { rejectWithValue, dispatch }) => {
    try {
      const response = await VendorService.createVendor(vendorData);
      dispatch(showToast({ type: 'success', message: 'Vendor created successfully' }));
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create vendor');
    }
  }
);

export const updateVendor = createAsyncThunk(
  'vendors/updateVendor',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await VendorService.updateVendor(id, data);
      dispatch(showToast({ type: 'success', message: 'Vendor updated successfully' }));
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update vendor');
    }
  }
);

export const deleteVendor = createAsyncThunk(
  'vendors/deleteVendor',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await VendorService.deleteVendor(id);
      dispatch(showToast({ type: 'success', message: 'Vendor deleted successfully' }));
      return id;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete vendor');
    }
  }
);

export const downloadVendorsWithFilters = createAsyncThunk(
  'vendors/downloadVendorsWithFilters',
  async (filters = {}, { rejectWithValue }) => {
    try {
      // Implement download logic here if needed

      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download vendors');
    }
  }
);

const vendorSlice = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setVendor: (state, action) => {
      state.filters.vendor = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.status = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = INITIAL_STATE.filters;
      state.searchTerm = '';
    },
    toggleTileView: (state) => {
      state.showTileView = !state.showTileView;
    },
    toggleFilterVisible: (state) => {
      state.filterVisible = !state.filterVisible;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorsWithFilters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorsWithFilters.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchVendorsWithFilters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createVendor.fulfilled, (state, action) => {
        state.data.push(action.payload);
      })
      .addCase(updateVendor.fulfilled, (state, action) => {
        const index = state.data.findIndex(vendor => vendor.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.data = state.data.filter(vendor => vendor.id !== action.payload);
      });
  },
});

export const { actions } = vendorSlice;
const { reducer } = vendorSlice;
redux.injectReducer(STORE_KEY, reducer);

 